import React from 'react';
import { Button, Modal } from '@/components';
import { useTranslation } from '@/i18n/client';

export interface CrowdModalProps {
  lang: string;
  onClose: () => void;
  onOk: () => void;
  isOpen: boolean;
}

export const CrowdModal: React.FC<CrowdModalProps> = ({ onClose, onOk, lang, isOpen = false }) => {
  const { t } = useTranslation(lang);
  return (
    <Modal className="z-99" background="bg-white" isOpen={isOpen} onClose={onClose}>
      <div className="w-100%">
        <span className="flex justify-center align-center text-sm font-normal mb-10">
          前方擁擠，請重試
        </span>
        <div className="flex justify-between">
          <Button
            className=" w-32 border-btn-green  text-base rounded-full"
            type="link"
            size="sm"
            paddingLeft="1.5"
            paddingRight="1.5"
            color="btn-green"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="w-32 text-white bg-btn-green text-base rounded-full"
            type="primary"
            size="sm"
            onClick={onOk}
          >
            {t('retry')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
